export default __webpack_public_path__ + "static/media/ic_empty_history.70c9a6ab.png";